import { CSSProperties } from "react";

const PlusIcon = ({ scale, color, style }: { scale?: number; color?: string; style?: CSSProperties }) => {
  let c = "#1062D0";
  if (color) c = color;
  return (
    <svg
      style={{ transform: `scale(${scale || 1})`,...style }}
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.9993 0.333313C11.353 0.333313 11.6921 0.473789 11.9421 0.723838C12.1922 0.973886 12.3327 1.31302 12.3327 1.66665V9.66665H20.3327C20.6863 9.66665 21.0254 9.80712 21.2755 10.0572C21.5255 10.3072 21.666 10.6464 21.666 11C21.666 11.3536 21.5255 11.6927 21.2755 11.9428C21.0254 12.1928 20.6863 12.3333 20.3327 12.3333H12.3327V20.3333C12.3327 20.6869 12.1922 21.0261 11.9421 21.2761C11.6921 21.5262 11.353 21.6666 10.9993 21.6666C10.6457 21.6666 10.3066 21.5262 10.0565 21.2761C9.80648 21.0261 9.66601 20.6869 9.66601 20.3333V12.3333H1.66601C1.31238 12.3333 0.973245 12.1928 0.723197 11.9428C0.473148 11.6927 0.332672 11.3536 0.332672 11C0.332672 10.6464 0.473148 10.3072 0.723197 10.0572C0.973245 9.80712 1.31238 9.66665 1.66601 9.66665H9.66601V1.66665C9.66601 1.31302 9.80648 0.973886 10.0565 0.723838C10.3066 0.473789 10.6457 0.333313 10.9993 0.333313Z"
        fill={c}
      />
    </svg>
  );
};

export default PlusIcon;
